<template>
  <div class="py-12 px-4">
    <div class="flex flex-col items-center mb-10">
      <h2 class="text-2xl font-bold mb-2">About</h2>
      <p class="text-gray-500 text-sm">代表について</p>
      <div class="w-12 h-1 bg-blue-500 mt-3 rounded"></div>
    </div>

    <div class="max-w-4xl mx-auto flex sm:flex-row flex-col gap-8">
      <div class="flex flex-col items-center sm:min-w-[12rem]">
        <img src="@/assets/K.K.jpg" alt="小島一也" class="w-40 h-40 rounded-full object-cover mb-3 shadow">
        <p class="text-center text-sm font-semibold text-gray-800">小島一也</p>
        <p class="text-center text-xs text-gray-500">代表兼エンジニア</p>
      </div>

      <div class="flex-1">
        <p class="text-sm text-gray-700 leading-relaxed mb-3">
          10年以上にわたりWebアプリケーションの開発者としてフリーランスで活動。Ruby・Python・Go言語をはじめとする多様なプログラミング言語と、AWS・GCPといったクラウドサービスを駆使したWebシステム開発を得意としています。
        </p>
        <p class="text-sm text-gray-700 leading-relaxed mb-3">
          これまで数々のプロジェクトに関与し、新技術の選定やシステム構築を中心的な役割として担当。システムの耐障害性向上や問題の迅速な調査・解消を行い、プロジェクトの成功に貢献してきました。
        </p>
        <p class="text-sm text-gray-700 leading-relaxed mb-6">
          Udemyでは延べ4万人以上に技術コンテンツを提供。技術書の執筆実績もあり、教育・発信活動にも力を入れています。
        </p>

        <h3 class="text-sm font-semibold text-gray-600 mb-3">使用技術</h3>
        <div class="flex flex-wrap gap-2 mb-6">
          <span v-for="tech in techStack" :key="tech.name"
            class="text-xs font-medium px-3 py-1 rounded-full"
            :class="tech.color">
            {{ tech.name }}
          </span>
        </div>

        <h3 class="text-sm font-semibold text-gray-600 mb-3">リンク</h3>
        <div class="flex flex-wrap gap-3">
          <a v-for="link in links" :key="link.label"
            :href="link.url" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full border border-gray-200 text-gray-600 hover:text-blue-600 hover:border-blue-400 transition-colors">
            <span>{{ link.icon }}</span>
            <span>{{ link.label }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RepresentativeDirector',
  data() {
    return {
      links: [
        { label: 'note', icon: '📝', url: 'https://note.com/kozy27' },
        { label: 'X (Twitter)', icon: '𝕏', url: 'https://x.com/kazuya104' },
        { label: 'GitHub', icon: '🐙', url: 'https://github.com/kkoji' },
        { label: 'テックブログ', icon: '💻', url: 'https://improver-tech.com/' },
        { label: 'Udemy', icon: '🎓', url: 'https://www.udemy.com/user/kazuya-kojima/' },
      ],
      techStack: [
        { name: 'Ruby on Rails', color: 'bg-red-100 text-red-700' },
        { name: 'Go', color: 'bg-cyan-100 text-cyan-700' },
        { name: 'Python', color: 'bg-yellow-100 text-yellow-700' },
        { name: 'Vue.js', color: 'bg-emerald-100 text-emerald-700' },
        { name: 'Next.js', color: 'bg-gray-100 text-gray-700' },
        { name: 'React', color: 'bg-sky-100 text-sky-700' },
        { name: 'AWS', color: 'bg-orange-100 text-orange-700' },
        { name: 'GCP', color: 'bg-blue-100 text-blue-700' },
        { name: 'Azure', color: 'bg-blue-100 text-blue-800' },
        { name: 'Docker', color: 'bg-sky-100 text-sky-700' },
        { name: 'Firebase', color: 'bg-amber-100 text-amber-700' },
        { name: 'PostgreSQL', color: 'bg-indigo-100 text-indigo-700' },
        { name: 'Solidity', color: 'bg-purple-100 text-purple-700' },
        { name: 'LangChain', color: 'bg-green-100 text-green-700' },
        { name: 'OpenAI API', color: 'bg-teal-100 text-teal-700' },
      ]
    }
  }
}
</script>
